<template lang='pug'>
  .fpui-input-text-addon(:class='{ error: error, "input-addon": addonLeft || addonRight }')
    .row
      .fpui-input-label-container.vcenter(
        @click='focus',
        :class='labelClass',
        v-if='label'
      )
        span {{ label | translate }}
        .required-container(v-if='required')
          i.fpui.fpui-required
        fpui-helper(v-if='helper', :text="helper | translate")
      .fpui-input-text-content.vcenter(:class='inputClass')
        .addon-container
          .addon.addon-left(v-if="addonLeft")  {{addonLeft | translate}}
          input(
            ref='input'
            :name='name'
            :placeholder="placeholder | translate"
            :type="type"
            :id="id"
            v-model='model'
            :class="className"
            :disabled="disabled"
            :autofocus='autofocus'
            @click="$emit('click', $event)"
          )
          .addon.addon-right(v-if="addonRight")  {{addonRight | translate}}
</template>

<script>

export default {
  props: {
    addonLeft: String,
    addonRight: String,
    id: {
      type: String,
      required: false,
      default () { return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10) }
    },
    name: { type: String },
    value: { required: true, default: '' },
    color: { type: String, default: 'blue' },
    disabled: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    placeholder: { type: String },
    autocomplete: { type: Array },
    type: { type: String, default: 'text' },
    autofocus: { type: Boolean, default: false },
    label: { type: String },
    labelSize: { type: Number, default: 3 },
    withPadding: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    helper: { type: String }
  },
  computed: {
    model: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    },
    className () {
      let className = [`fpui-input-color-${this.color}`]
      if (this.disabled) className.push('disabled')
      if (this.error) className.push('error')
      return className.join(' ')
    },
    inputClass () {
      let className = []
      let size = 12
      if (this.label) size -= this.labelSize
      className.push(`col-xs-${size}`)
      if (this.withPadding) className.push('with-padding')
      return className.join(' ')
    },
    labelClass () {
      let className = [`col-xs-${this.labelSize}`]
      if (this.withPadding) className.push('with-padding')
      return className.join(' ')
    }
  },
  methods: {
    focus () { this.$refs.input && this.$refs.input.focus() }
  }
}
</script>

<style lang='less'>
@import "~@/shared/styles/_variables.less";
.fpui-input-text-addon {
  display: inline-block;
  width: 100%;
  position:relative;
  .fpui-input-label-container {
    padding-left: 0;
    cursor: pointer;
    .required-container {
      display: inline-block;
      margin-right: 7px;
      margin-top: -10px;
      width: 15px;
      vertical-align: middle;
      font-size: 22px;
      text-align: center;
      color: @blue;
      border-radius: 50%;
    }
  }
  .fpui-input-text-content:not(.with-padding) {
    padding: 0;
  }
  input {
    width: 100%;
    border-radius: 2px;
    background: #FFF none repeat scroll 0% 0%;
    padding: 8px;
    border: 1px solid @grey;
    font-size: 1em;
    font-weight: 300;
    letter-spacing: 1px;
    outline: none;
    &:disabled {
      background: #eee;
    }
    .input-transition();
    &.fpui-input-color-blue:not(.error):focus {
      border-color: @blue;
    }
    &.fpui-input-color-green:not(.error):focus {
      border-color: @green;
    }
    &.fpui-input-color-red:focus, &.error {
      border-color: @red;
    }
    &.fpui-input-color-yellow:not(.error):focus {
      border-color: @yellow;
    }
  }
  &.input-addon {
    .fpui-input-text-content .addon-container {
      position: relative;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      .addon {
        padding: .5rem .75rem;
        margin-bottom: 0;
        font-size: 1em;
        font-weight: 400;
        line-height: 1.25;
        color: @blue;
        text-align: center;
        background-color: #FFF;
        border: 1px solid @grey;
        white-space: nowrap;
        vertical-align: middle;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center;
      }
      input:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left: none;
      }
      input:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right: none;
      }
      input:not(:first-child):not(:last-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-left: none;
        border-right: none;
      }
    }
  }
}
</style>
